export const cifBo = ["301 205","<g fill-rule='nonzero' fill='none'><path fill='#007934' d='M.5.227h300v204.545H.5z'/><path fill='#F9E300' d='M.5.227h300v136.364H.5z'/><path fill='#D52B1E' d='M.5.227h300v68.182H.5z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-bo.js
// module id = null
// module chunks = 